import { render, staticRenderFns } from "./nutrition-panel.html?vue&type=template&id=41d4fbc5&scoped=true&"
import script from "./nutrition-panel.js?vue&type=script&lang=js&"
export * from "./nutrition-panel.js?vue&type=script&lang=js&"
import style0 from "./nutrition-panel.scss?vue&type=style&index=0&id=41d4fbc5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d4fbc5",
  null
  
)

export default component.exports